import React, { useState } from 'react'

const ERROR_IMG_SRC =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg=='
  

export function ImageWithFallback(props) {
  const [didError, setDidError] = React.useState(false)

  React.useEffect(() => {
    setDidError(false);
  }, [props.src]);

  const handleError = () => {
    setDidError(true)
  }

  const { src, alt, style, className, fetchPriority, decoding, ...rest } = props
  
  // Convert fetchPriority to the correct HTML attribute name
  const imgProps = {
    ...rest,
    ...(fetchPriority && { fetchpriority: fetchPriority }),
    ...(decoding && { decoding })
  }

  return didError ? (
    <div
      className={`inline-block bg-gray-100 text-center align-middle ${className ?? ''}`}
      style={style}
    >
      <div className="flex items-center justify-center w-full h-full">
        <img src={ERROR_IMG_SRC} alt={alt || "Failed to load"} {...imgProps} data-original-url={src} decoding="async" />
      </div>
    </div>
  ) : (
    <img src={src} alt={alt} loading='lazy' decoding='async' className={className} style={style} {...imgProps} onError={handleError} />
  )
}
